import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postCreateServicesMaster } from "apis";
import { getServicesMasterAutosuggestQuery } from "./use-get-services-master-autosuggest";
import { getServicesMasterInfiniteScrollQuery } from "./use-get-services-master-infinite-query";
import { useMyAccessProfileV2 } from "../../tryst/get-my-access-profile";

export default function usePostCreateServicesMaster({
  clinic_id,
}: {
  clinic_id: string;
}) {
  const queryClient = useQueryClient();
  const { data: myAccessProfile } = useMyAccessProfileV2();

  return useMutation(postCreateServicesMaster, {
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries(
          getServicesMasterAutosuggestQuery({
            owner_id: myAccessProfile?.business?.id!,
            clinic_id,
          })
        );
        queryClient.invalidateQueries(
          getServicesMasterInfiniteScrollQuery({
            owner_id: myAccessProfile?.business?.id!,
            clinic_id,
          })
        );
      }, 100);
    },
  });
}
